// extracted by mini-css-extract-plugin
export default {"zone":"upload-zone_zone__LSj8U","input":"upload-zone_input__H73fp","fileList":"upload-zone_fileList__ruFZ7","preview":"upload-zone_preview__bAhj1","icon":"upload-zone_icon__6kEWB"};